export default __webpack_public_path__ + "static/media/teams.455452bb.svg";